module.exports = __webpack_public_path__ + "static/media/mercado-libre.94064bbe.svg";